module.exports = __webpack_public_path__ + "static/media/boldsign-logo.c4272e68.png";